import { EventType } from 'matrix-js-sdk';
import mcli from '.';
let hasWarnedInvalidMDirect = false;
export const filterValidMDirect = (content) => {
    if (content === null || typeof content !== 'object') {
        return {
            valid: false,
            filteredContent: {},
        };
    }
    const filteredContent = new Map();
    let valid = true;
    for (const [userId, roomIds] of Object.entries(content)) {
        if (typeof userId !== 'string' || !Array.isArray(roomIds)) {
            valid = false;
            continue;
        }
        const filteredRoomIds = [];
        filteredContent.set(userId, filteredRoomIds);
        for (const roomId of roomIds) {
            if (typeof roomId === 'string') {
                filteredRoomIds.push(roomId);
            }
            else {
                valid = false;
            }
        }
    }
    return {
        valid,
        filteredContent: Object.fromEntries(filteredContent.entries()),
    };
};
export const getSanitizedMDirectContent = () => {
    const mDirectEvent = mcli.getAccountData(EventType.Direct);
    const { valid, filteredContent } = filterValidMDirect(mDirectEvent?.getContent() ?? {});
    if (!valid && !hasWarnedInvalidMDirect) {
        hasWarnedInvalidMDirect = true;
        console.warn('Invalid m.direct content detected. Ignoring malformed entries.');
    }
    return filteredContent;
};
